export default {"src":"/_next/static/media/getFreeBook.0608008f.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};